<template>
  <div class="influsightslogin" >
    <br>
    <h1 style="font-size:50px;font-weight:bold;"> Vamp InfluSights </h1>
    <br>
    <br>
        <div class="container">
            <div class="row justify-content-center">
                <br>
              <div class="container">
                  <div id="response"></div>
                  <h3 id="ig-connect-header"></h3>
                  <div id="pages" align="center" ></div>
                  <div id="profile" align="center" ></div>
                  <br>
                  <button id="loginBtn" class="button" onClick="fblogin()">Login with Facebook</button>
              </div>
                <br>
                <br>
                <br>
            </div>
             <br>
            <div id="status"></div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InfluSightsLogin.vue